import { gql } from '@apollo/client'

/**
 * Mutation to add external tracking link
 */
export const ADD_EXTERNAL_TRACKING_SOURCE = gql`
  mutation AddExternalTrackingLinkSource($url: String!, $shipmentID: ID!) {
    addExternalTrackingLinkSource(input: { url: $url, shipmentID: $shipmentID }) {
      addedAt
      isActive
      metadata {
        errors {
          date
          code
          rawMessage
        }
        isSupported
        provider
        securityMessage
        url
      }
      source
      sourceID
    }
  }
`

/**
 * Mutation to add tive device ID
 */
export const ADD_TIVE_DEVICE_ID = gql`
  mutation AddTiveDeviceSource($tiveDeviceID: String!, $shipmentID: ID!) {
    addTiveDeviceSource(input: { tiveDeviceID: $tiveDeviceID, shipmentID: $shipmentID }) {
      addedAt
      isActive
      locations {
        coordinates {
          latitude
          longitude
        }
        locationInfo
        timestamp
      }
      metadata {
        errors {
          date
          code
          rawMessage
        }
        provider
        tiveDeviceID
      }
      source
      sourceID
    }
  }
`

/**
 * Mutation to remove tive device ID
 */
export const REMOVE_TIVE_DEVICE_ID = gql`
  mutation RemoveTiveDeviceSource($tiveDeviceID: String!, $shipmentID: ID!) {
    removeTiveDeviceSource(input: { tiveDeviceID: $tiveDeviceID, shipmentID: $shipmentID }) {
      addedAt
      isActive
      locations {
        coordinates {
          latitude
          longitude
        }
        locationInfo
        timestamp
      }
      metadata {
        errors {
          date
          code
          rawMessage
        }
        provider
        tiveDeviceID
      }
      source
      sourceID
    }
  }
`

/**
 * Mutation to resend download link
 */
export const SEND_APP_DOWNLOAD_LINK = gql`
  mutation SendDownloadLink(
    $shipmentID: String!
    $shipmentNumber: String!
    $userID: String!
    $shipmentOwnerWorkspaceID: String!
  ) {
    sendAppDownloadLink(
      input: {
        shipmentID: $shipmentID
        shipmentNumber: $shipmentNumber
        userID: $userID
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
      }
    ) {
      id
    }
  }
`

/**
 * Mutation to remove external tracking link
 */
export const REMOVE_EXTERNAL_TRACKING_SOURCE = gql`
  mutation RemoveExternalTrackingLinkSource($url: String!, $shipmentID: ID!) {
    removeExternalTrackingLinkSource(input: { url: $url, shipmentID: $shipmentID }) {
      addedAt
      isActive
      metadata {
        errors {
          date
          code
          rawMessage
        }
        isSupported
        provider
        securityMessage
        url
      }
      source
      sourceID
    }
  }
`

/**
 * Mutation to update stop coordinates
 */
export const UPDATE_STOP_COORDINATES = gql`
  mutation UpdateStopCoordinates(
    $address: JSON!
    $locationID: String!
    $shipmentID: String!
    $shipmentOwnerEnterpriseWorkspaceID: String
    $shipmentOwnerWorkspaceID: String
    $stopID: String!
  ) {
    updateStopCoordinates(
      input: {
        address: $address
        locationID: $locationID
        shipmentID: $shipmentID
        shipmentOwnerEnterpriseWorkspaceID: $shipmentOwnerEnterpriseWorkspaceID
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        stopID: $stopID
      }
    ) {
      locationID
    }
  }
`
